import axios from 'axios'

const API_PATH = 'api/v2/admins/customers/refunds/payments'

const CustomerRefundPaymentsApiV2 = {

  /**
   * Get list of Customer Refund Payments
   * Invoke `GET api/v2/admins/customers/refunds/payments'
   * @param {object} tableState - ReactTable final state
   */
  get: async (params) => {
    const path = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Get detail of Customer Refund Payment by ID
   * Invoke `GET api/v2/admins/customers/refunds/payments/:id`
   */
  show: async (refundPaymentId) => {
    const path = `${API_PATH}/${refundPaymentId}`

    const response = axios.get(path)
    return response
  },

  /**
   * Update refund payment data with evidence image
   * Invoke `PATCH api/v2/admins/customers/refunds/payments/:id/complete`
   * @param {number} id - refund payment ID
   * @param {binary} image - evidence image
   * @param {object} paymentDetail - payload data that includes transaction_no, tl_debit_bank_id, & transferred_at
   */
  complete: async ( id, image, paymentDetail ) => {
    const path = `${API_PATH}/${id}/complete`
    let params = {
      transaction_no : paymentDetail.transaction_no,
      tl_bank_id     : paymentDetail.tl_bank_id,
      transferred_at : paymentDetail.transferred_at,
      payment_cost   : paymentDetail.payment_cost
    }
    if (image.size !== 0) params['transferred_evidence_image'] = image

    let payload = new FormData()

    //append params to formData
    Object.keys(params).forEach((mainKey) => {
      payload.append(mainKey, params[mainKey])
    })

    const response = axios.patch(path, payload)
    return response
  }
}

export default CustomerRefundPaymentsApiV2
